<div class="card-header" >
  <app-breadcrumb currentPage="banktransacties inlezen"></app-breadcrumb>
</div>

<div class="card-body">
  <h2>1. download de bankbestanden</h2>
  <app-uitleg-bank-transacties-downloaden></app-uitleg-bank-transacties-downloaden>

  <div class="spacer-small"></div>
  <button class="btn btn-left arrow-left" [routerLink]="'/bewind/' + clientId + '/importeren'">
    kies een andere bank
  </button>

  <div class="spacer"></div>
  <h2>2. sleep hier uw bankbestanden</h2>

  <div class="spacer"></div>
  <div class="container relative" appDragAndDrop (fileDropped)="onFileDropped($event)">
    <input type="file" id="fileDropRef" multiple (change)="fileBrowseHandler($event)" />
    <svg xmlns="http://www.w3.org/2000/svg" width="63" height="64" viewBox="0 0 63 64">
      <g fill="#03738c" fill-rule="nonzero">
        <path
          d="M42.656 15.135a1.953 1.953 0 0 1-1.391-.578L31.5 4.795l-9.765 9.762a1.97 1.97 0 1 1-2.785-2.785L30.106.616a1.97 1.97 0 0 1 2.785 0l11.157 11.156a1.97 1.97 0 0 1-1.392 3.363z" />
        <path
          d="M31.5 36.791a1.97 1.97 0 0 1-1.969-1.969V2.01a1.97 1.97 0 0 1 3.938 0v32.812a1.97 1.97 0 0 1-1.969 1.969z" />
        <path
          d="M55.781 63.041H7.22A7.225 7.225 0 0 1 0 55.822V41.385a4.599 4.599 0 0 1 4.594-4.594h7.234a4.567 4.567 0 0 1 4.402 3.276l2.814 9.382a.658.658 0 0 0 .628.467h23.656a.658.658 0 0 0 .628-.467l2.814-9.385a4.572 4.572 0 0 1 4.402-3.273h7.234A4.599 4.599 0 0 1 63 41.385v14.437a7.225 7.225 0 0 1-7.219 7.219zM4.594 40.729a.656.656 0 0 0-.657.656v14.437a3.286 3.286 0 0 0 3.282 3.282H55.78a3.286 3.286 0 0 0 3.282-3.282V41.385a.656.656 0 0 0-.657-.656h-7.234a.65.65 0 0 0-.628.467L47.73 50.58a4.628 4.628 0 0 1-4.402 3.274H19.672a4.567 4.567 0 0 1-4.402-3.276l-2.814-9.382a.65.65 0 0 0-.628-.467H4.594z" />
      </g>
    </svg>
    <div class="f20 b mt14">sleep MT940-/CSV-bestanden <br>of</div>
    <label for="fileDropRef" class="btn plus mb14">selecteer</label>
  </div>
  <div class="files-list">
    <div class="single-file" *ngFor="let file of files; let i = index">
      <div class="file-icon" style="width: 90px">
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 58 58" style="width: 65px" xml:space="preserve">
          <polygon style="fill:#EDEADA;" points="51.5,14 37.5,0 6.5,0 6.5,58 51.5,58 " />
          <g>
            <path style="fill:#CEC9AE;"
                  d="M16.5,23h25c0.552,0,1-0.447,1-1s-0.448-1-1-1h-25c-0.552,0-1,0.447-1,1S15.948,23,16.5,23z" />
            <path style="fill:#CEC9AE;"
                  d="M16.5,15h10c0.552,0,1-0.447,1-1s-0.448-1-1-1h-10c-0.552,0-1,0.447-1,1S15.948,15,16.5,15z" />
            <path style="fill:#CEC9AE;"
                  d="M41.5,29h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,29,41.5,29z" />
            <path style="fill:#CEC9AE;"
                  d="M41.5,37h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,37,41.5,37z" />
            <path style="fill:#CEC9AE;"
                  d="M41.5,45h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,45,41.5,45z" />
          </g>
          <polygon style="fill:#CEC9AE;" points="37.5,0 37.5,14 51.5,14 " />
        </svg>
      </div>
      <div class="info">
        <h4 class="name">{{ file?.name }}</h4>
        <p class="size">{{ formatBytes(file?.size, 2) }}</p>
        <p *ngIf="file.error != null">
          <span style="color:#cb4c4c; font-weight: bold; text-decoration: underline; margin-bottom:0; font-size:14px;">{{file?.error}}</span>
          <span style="display:inline-block; margin-left:10px; font-size:14px;cursor: pointer" (click)="reset(file)">Opnieuw proberen?</span>
        </p>
        <app-progress *ngIf="file.progress > 1" [status]="file.status" [progress]="file?.progress"></app-progress>
      </div>
      <div *ngIf="!isUploading && (!file.inProgress && file.progress !== 100) || file.status == status.FAILED" class="delete hover-nudge" (click)="deleteFile(i)">
       <mat-icon>delete_outline</mat-icon>
      </div>
    </div>
  </div>

  <div class="spacer-small"></div>
  <button class="btn plus btn-left" *ngIf="canUpload()" (click)="upload()">uploaden</button>
  <div class="clearFix"></div>

  <div class="spacer-small"></div>
  <p>
    Als u vragen heeft over het inlezen van banktransacties neem dan contact op via de chat rechtsonder of door te mailen naar <a class="link" href="mailto:info@reveon.nl">info@reveon.nl</a>.
  </p>
</div>
